import moment from 'moment';
import {BaseShiftCard} from './base-shift-card';

interface CareServiceCardProps {
  label?: string;
  startHour: string;
  endHour: string;
  borderColor?: string;
  onClick?: () => void;
}

export function CareServiceCard(props: CareServiceCardProps) {
  return (
    <BaseShiftCard
      label={props.label ?? ''}
      borderColor={props.borderColor || '#ffe'}
      startHour={moment(props.startHour)}
      endHour={moment(props.endHour)}
      onClick={props.onClick}
    />
  );
}
